/* =============================================================================
   Forevermore Magnets — pickup.js
   Client-side weekend cutoff logic for show pickup, driven entirely by
   theme settings serialized into #fm-pickup-config by layout/theme.liquid.

   Rules (all editable via theme settings):
   - Pickup only offered while "Show pickup is currently available" is on.
   - On SATURDAY after the Saturday cutoff (default 3:00 p.m.), Saturday
     pickup is no longer selectable — Sunday pickup remains.
   - On SUNDAY after the Sunday cutoff (default 3:00 p.m.), show pickup is
     hidden entirely for the rest of the weekend.

   ⚠  UX LAYER ONLY — this script uses the customer's browser clock.
   Checkout-level enforcement (immune to clock manipulation) is provided by
   the Shopify Functions delivery customization in functions/extensions/
   pickup-cutoff/. See README → "Show pickup — configuration and enforcement"
   for the two-step setup (Local Pickup in Shopify admin + deploy the function).
   ========================================================================== */
(function () {
  'use strict';

  var configEl = document.getElementById('fm-pickup-config');
  if (!configEl) return;

  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
  if (!config || !config.enabled) return;

  function parseCutoff(text, fallback) {
    var m = /^(\d{1,2}):(\d{2})$/.exec((text || '').trim());
    if (!m) m = /^(\d{1,2}):(\d{2})$/.exec(fallback);
    return { h: parseInt(m[1], 10), m: parseInt(m[2], 10) };
  }

  var satCutoff = parseCutoff(config.satCutoff, '15:00');
  var sunCutoff = parseCutoff(config.sunCutoff, '15:00');

  var now = new Date();
  var day = now.getDay(); // 0 = Sunday, 6 = Saturday
  var minutes = now.getHours() * 60 + now.getMinutes();

  var satPast = day === 6 && minutes >= satCutoff.h * 60 + satCutoff.m;
  var sunPast = day === 0 && minutes >= sunCutoff.h * 60 + sunCutoff.m;

  var pickupOption = document.querySelector('[data-pickup-option]');
  var pickupRadio = document.getElementById('FulfillPickup');
  var shipRadio = document.getElementById('FulfillShip');
  var pickupFields = document.querySelector('[data-pickup-fields]');
  var unavailableMsg = document.querySelector('[data-pickup-unavailable]');
  var daySelect = document.querySelector('[data-pickup-day]');

  // --- Sunday past cutoff: hide pickup entirely -----------------------------
  if (sunPast) {
    if (pickupOption) pickupOption.hidden = true;
    if (pickupRadio) { pickupRadio.checked = false; pickupRadio.disabled = true; }
    if (shipRadio) shipRadio.checked = true;
    if (pickupFields) pickupFields.hidden = true;
    if (unavailableMsg) {
      unavailableMsg.hidden = false;
      unavailableMsg.textContent =
        'Show pickup has closed for this weekend (orders after ' +
        formatCutoff(sunCutoff) + ' Sunday can no longer be made before the show ends). ' +
        'Your order will ship instead.';
    }
    return;
  }

  // --- Saturday past cutoff: remove the Saturday pickup-day choice ----------
  if (satPast && daySelect) {
    var satOption = daySelect.querySelector('option[value="Saturday"]');
    if (satOption) {
      satOption.disabled = true;
      satOption.textContent = satOption.textContent.replace(/\)?$/, '') + ' — closed for today';
      if (daySelect.value === 'Saturday') daySelect.value = 'Sunday';
    }
    if (unavailableMsg) {
      unavailableMsg.hidden = false;
      unavailableMsg.textContent =
        'It\u2019s past ' + formatCutoff(satCutoff) +
        ' — new orders can no longer be picked up today, but Sunday pickup is still available.';
    }
  }

  // --- Toggle the pickup detail fields with the radio ------------------------
  function syncFields() {
    if (!pickupFields) return;
    var on = pickupRadio && pickupRadio.checked;
    pickupFields.hidden = !on;
    pickupFields.querySelectorAll('input, select, textarea').forEach(function (el) {
      el.disabled = !on;
    });
  }
  if (pickupRadio) pickupRadio.addEventListener('change', syncFields);
  if (shipRadio) shipRadio.addEventListener('change', syncFields);
  syncFields();

  function formatCutoff(c) {
    var h12 = c.h % 12 === 0 ? 12 : c.h % 12;
    var suffix = c.h >= 12 ? 'p.m.' : 'a.m.';
    return h12 + (c.m ? ':' + String(c.m).padStart(2, '0') : '') + ' ' + suffix;
  }
})();
